import SubmitCard from "./components/SubmitCard";
import Distribution from "./components/Distribution";
import PhishBoxList from "./components/PhishBoxList";
import PhishBoxHealth from "./components/PhishBoxHealth";
import ContainerServices from "../../Components/PagesComponents/Dashboard/ContainerServices/ContainerServices";

import "./styles.scss";

const PhishBox = () => {
  return (
    <div className="phishbox">
      <div className="phishbox__header">
        <h1>PhishBox</h1>
      </div>
      <div className="phishbox__body">
        <SubmitCard />
        <Distribution />
        <PhishBoxList />
        <div className="phishbox__body__services-container">
          <PhishBoxHealth />
          <ContainerServices />
        </div>
        
      </div>
    </div>
  );
};

export default PhishBox;
